import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * True below the `md` breakpoint — the width at which the stylesheets switch to
 * their phone rules.
 *
 * Every component that needs to know "is this a phone?" asks through here so
 * there is one definition of narrow. The theme's breakpoint values mirror the
 * SCSS token map, so this flips at the same width the CSS does; see the
 * `breakpoint-max` comment in scss/core/_variables.scss.
 *
 * @returns {Boolean} Whether the viewport is narrower than the md breakpoint
 */
export const useIsNarrowScreen = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};
